<template>
  <div class="payment-method">
    <div class="payment-method__title">
      <m4-radio :name="inputName" :native-value="inputValue" class="payment-method__radio">
        <m4-icon :icon="icon" class="payment-method__icon"></m4-icon>
        <span class="payment-method__title__text">
          {{ title }}
        </span>
        <span class="payment-method__title__check">
          <m4-icon icon="check-thin"></m4-icon>
        </span>
      </m4-radio>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4PaymentMethod",
  data() {
    return {};
  },
  props: {
    inputName: {
      type: String,
      required: true
    },
    inputValue: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false
    }
  }
};
</script>
